import { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { GLASS, GLASS_SM } from './glass';

function FAQItem({ item, isOpen, onToggle }) {
    return (
        <div className={`overflow-hidden ${GLASS_SM}`}>
            <button
                onClick={onToggle}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-accent/50 transition-colors"
                aria-expanded={isOpen}
            >
                <span className="font-semibold text-foreground text-[15px] pr-4">{item.q}</span>
                <ChevronDown
                    size={18}
                    className={`text-muted-foreground shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>
            <motion.div
                initial={false}
                animate={{ height: isOpen ? 'auto' : 0, opacity: isOpen ? 1 : 0 }}
                transition={{ duration: 0.25 }}
                className="overflow-hidden"
            >
                <p className="px-5 pb-5 text-sm text-muted-foreground leading-relaxed">
                    {item.a}
                </p>
            </motion.div>
        </div>
    );
}

export function FAQSection() {
    const { t, lang } = useLanguage();
    const [openIdx, setOpenIdx] = useState(null);
    const items = t('faq.items');

    const toggle = (i) => setOpenIdx(prev => prev === i ? null : i);

    return (
        <section className="section-padding relative" id="faq" style={{ scrollMarginTop: '120px' }}>
            <div className="section-container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className={`mb-5 max-w-2xl px-6 py-5 sm:px-8 sm:py-6 ${GLASS}`}
                >
                    <h2 className="heading-lg text-foreground">{t('faq.title')}</h2>
                </motion.div>

                <div className="max-w-2xl space-y-3">
                    {Array.isArray(items) && items.slice(0, 6).map((item, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: i * 0.05 }}
                        >
                            <FAQItem
                                item={item}
                                isOpen={openIdx === i}
                                onToggle={() => toggle(i)}
                            />
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    className="mt-8"
                >
                    <a
                        href="/faq"
                        className="text-primary font-semibold text-sm hover:underline"
                        data-testid="faq-view-all"
                    >
                        {lang === 'nl' ? 'Bekijk alle veelgestelde vragen →' : 'See all questions →'}
                    </a>
                </motion.div>
            </div>
        </section>
    );
}
